import { useState, useEffect, useRef } from 'react';

// Automatic tooltip component for table headers that detects text overflow
const TooltipHeader = ({ text }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const headerRef = useRef(null);

    useEffect(() => {
        const checkOverflow = () => {
            if (headerRef.current) {
                const isOverflowing = headerRef.current.scrollWidth > headerRef.current.clientWidth;
                setShowTooltip(isOverflowing);
            }
        };

        // Initial check with multiple fallbacks
        checkOverflow();
        const timeoutId1 = setTimeout(checkOverflow, 100);
        const timeoutId2 = setTimeout(checkOverflow, 300);
        const timeoutId3 = setTimeout(checkOverflow, 600);

        // Use ResizeObserver for more reliable detection
        let resizeObserver;
        if (headerRef.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(() => {
                checkOverflow();
            });
            resizeObserver.observe(headerRef.current);
        }

        // Fallback to resize event
        window.addEventListener('resize', checkOverflow);

        return () => {
            clearTimeout(timeoutId1);
            clearTimeout(timeoutId2);
            clearTimeout(timeoutId3);
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            window.removeEventListener('resize', checkOverflow);
        };
    }, [text]);

    if (!text) return <span>-</span>;

    return (
        <span
            ref={headerRef}
            title={showTooltip ? text : undefined}
            style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                maxWidth: '100%',
            }}
        >
            {text}
        </span>
    );
};

export default TooltipHeader;
